module.exports = __webpack_public_path__ + "media/images/failed-660093b7e4e161d1db223134ec98cb6e.svg";